import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchAllLeaveReport = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/leave/count/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all leave Report');
        }
    }
);

export const fetchAllLeaveReportDetails = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/leave/details/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all leave Report');
        }
    }
);
export const fetchAllLeaveCountByEmployeeId = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async ( Id : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/leave/employeeId/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all leave Report');
        }
    }
);